import Layout from '../components/layout/Layout';
import SectionLabel from '../components/shared/SectionLabel';
import SEO from '../components/shared/SEO';
import '../styles/termspage.css';

const sections = [
  {
    id: 'introduction',
    number: '01',
    heading: 'Terms & Conditions',
    body: (
      <>
        <p>
          Welcome to <strong>apexdefilabs.com</strong>. These terms and conditions outline the rules and
          regulations for the use of Apex DeFi Labs' website, located at{' '}
          <strong>https://apexdefilabs.com/</strong>.
        </p>
        <p>
          By accessing this website we assume you accept these terms and conditions. Do not continue to use
          apexdefilabs.com if you do not agree to take all of the terms and conditions stated on this page.
        </p>
        <p>
          The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer
          Notice and all Agreements: <strong>"Client"</strong>, <strong>"You"</strong> and{' '}
          <strong>"Your"</strong> refers to you, the person accessing this website and compliant to the
          Company's terms and conditions. <strong>"The Company"</strong>, <strong>"Ourselves"</strong>,{' '}
          <strong>"We"</strong>, <strong>"Our"</strong> and <strong>"Us"</strong>, refers to our Company.{' '}
          <strong>"Party"</strong>, <strong>"Parties"</strong>, or <strong>"Us"</strong>, refers to both the
          Client and ourselves. All terms refer to the offer, acceptance and consideration of payment
          necessary to undertake the process of our assistance to the Client in the most appropriate manner
          for the express purpose of meeting the Client's needs in respect of provision of the Company's
          stated services, in accordance with and subject to, prevailing law of Netherlands.
        </p>
      </>
    ),
  },
  {
    id: 'cookies',
    number: '02',
    heading: 'Cookies',
    body: (
      <>
        <p>
          We employ the use of cookies. By accessing apexdefilabs.com, you agreed to use cookies in
          agreement with Apex DeFi Labs' Privacy Policy.
        </p>
        <p>
          Most interactive websites use cookies to let us retrieve the user's details for each visit.
          Cookies are used by our website to enable the functionality of certain areas to make it easier for
          people visiting our website. Some of our affiliate/advertising partners may also use cookies.
        </p>
      </>
    ),
  },
  {
    id: 'license',
    number: '03',
    heading: 'License',
    body: (
      <>
        <p>
          Unless otherwise stated, Apex DeFi Labs and/or its licensors own the intellectual property rights
          for all material on apexdefilabs.com. All intellectual property rights are reserved. You may
          access this from apexdefilabs.com for your own personal use subjected to restrictions set in these
          terms and conditions.
        </p>
        <p>You must not:</p>
        <ul>
          <li>Republish material from apexdefilabs.com</li>
          <li>Sell, rent or sub-license material from apexdefilabs.com</li>
          <li>Reproduce, duplicate or copy material from apexdefilabs.com</li>
          <li>Redistribute content from apexdefilabs.com</li>
        </ul>
        <p>This Agreement shall begin on the date hereof.</p>
      </>
    ),
  },
  {
    id: 'comments',
    number: '04',
    heading: 'Comments',
    body: (
      <>
        <p>
          Parts of this website offer an opportunity for users to post and exchange opinions and information
          in certain areas of the website. Apex DeFi Labs does not filter, edit, publish or review Comments
          prior to their presence on the website. Comments do not reflect the views and opinions of Apex
          DeFi Labs, its agents and/or affiliates. Comments reflect the views and opinions of the person who
          posts their views and opinions.
        </p>
        <p>
          To the extent permitted by applicable laws, Apex DeFi Labs shall not be liable for the Comments
          or for any liability, damages or expenses caused and/or suffered as a result of any use of and/or
          posting of and/or appearance of the Comments on this website.
        </p>
        <p>
          Apex DeFi Labs reserves the right to monitor all Comments and to remove any Comments which can be
          considered inappropriate, offensive or causes breach of these Terms and Conditions.
        </p>
        <p>You warrant and represent that:</p>
        <ul>
          <li>
            You are entitled to post the Comments on our website and have all necessary licenses and
            consents to do so;
          </li>
          <li>
            The Comments do not invade any intellectual property right, including without limitation
            copyright, patent or trademark of any third party;
          </li>
          <li>
            The Comments do not contain any defamatory, libelous, offensive, indecent or otherwise unlawful
            material which is an invasion of privacy;
          </li>
          <li>
            The Comments will not be used to solicit or promote business or custom or present commercial
            activities or unlawful activity.
          </li>
        </ul>
        <p>
          You hereby grant Apex DeFi Labs a non-exclusive license to use, reproduce, edit and authorize
          others to use, reproduce and edit any of your Comments in any and all forms, formats or media.
        </p>
      </>
    ),
  },
  {
    id: 'hyperlinking',
    number: '05',
    heading: 'Hyperlinking to our Content',
    body: (
      <>
        <p>
          The following organizations may link to our Website without prior written approval:
        </p>
        <ul>
          <li>Government agencies;</li>
          <li>Search engines;</li>
          <li>News organizations;</li>
          <li>
            Online directory distributors may link to our Website in the same manner as they hyperlink to
            the Websites of other listed businesses; and
          </li>
          <li>
            System wide Accredited Businesses except soliciting non-profit organizations, charity shopping
            malls, and charity fundraising groups.
          </li>
        </ul>
        <p>
          These organizations may link to our home page, to publications or to other Website information so
          long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship,
          endorsement or approval of the linking party and its products and/or services; and (c) fits within
          the context of the linking party's site.
        </p>
        <p>
          We may consider and approve other link requests from the following types of organizations:
          commonly-known consumer and/or business information sources; dot.com community sites; associations
          or other groups representing charities; online directory distributors; internet portals;
          accounting, law and consulting firms; and educational institutions and trade associations.
        </p>
        <p>
          If you are one of these organizations and are interested in linking to our website, you must
          inform us by sending an e-mail to Apex DeFi Labs. Please include your name, your organization
          name, contact information as well as the URL of your site and a list of any URLs from which you
          intend to link to our Website. Allow 2–3 weeks for a response.
        </p>
        <p>No use of Apex DeFi Labs' logo or other artwork will be allowed for linking absent a trademark license agreement.</p>
      </>
    ),
  },
  {
    id: 'iframes',
    number: '06',
    heading: 'iFrames',
    body: (
      <p>
        Without prior approval and written permission, you may not create frames around our Webpages that
        alter in any way the visual presentation or appearance of our Website.
      </p>
    ),
  },
  {
    id: 'content-liability',
    number: '07',
    heading: 'Content Liability',
    body: (
      <p>
        We shall not be held responsible for any content that appears on your Website. You agree to protect
        and defend us against all claims that are rising on your Website. No link(s) should appear on any
        Website that may be interpreted as libelous, obscene or criminal, or which infringes, otherwise
        violates, or advocates the infringement or other violation of, any third party rights.
      </p>
    ),
  },
  {
    id: 'privacy',
    number: '08',
    heading: 'Your Privacy',
    body: (
      <p>Please read Privacy Policy</p>
    ),
  },
  {
    id: 'reservation',
    number: '09',
    heading: 'Reservation of Rights',
    body: (
      <p>
        We reserve the right to request that you remove all links or any particular link to our Website. You
        approve to immediately remove all links to our Website upon request. We also reserve the right to
        amend these terms and conditions and its linking policy at any time. By continuously linking to our
        Website, you agree to be bound to and follow these linking terms and conditions.
      </p>
    ),
  },
  {
    id: 'removal',
    number: '10',
    heading: 'Removal of Links',
    body: (
      <>
        <p>
          If you find any link on our Website that is offensive for any reason, you are free to contact and
          inform us at any moment. We will consider requests to remove links but we are not obligated to do
          so or to respond to you directly.
        </p>
        <p>
          We do not ensure that the information on this website is correct; we do not warrant its
          completeness or accuracy; nor do we promise to ensure that the website remains available or that
          the material on the website is kept up to date.
        </p>
      </>
    ),
  },
  {
    id: 'disclaimer',
    number: '11',
    heading: 'Disclaimer',
    body: (
      <>
        <p>
          To the maximum extent permitted by applicable law, we exclude all representations, warranties and
          conditions relating to our website and the use of this website.
        </p>
        <p>Nothing in this disclaimer will:</p>
        <ul>
          <li>limit or exclude our or your liability for death or personal injury;</li>
          <li>limit or exclude our or your liability for fraud or fraudulent misrepresentation;</li>
          <li>
            limit any of our or your liabilities in any way that is not permitted under applicable law; or
          </li>
          <li>exclude any of our or your liabilities that may not be excluded under applicable law.</li>
        </ul>
        <p>
          As long as the website and the information and services on the website are provided free of
          charge, we will not be liable for any loss or damage of any nature.
        </p>
      </>
    ),
  },
];

const tocLinks = [
  { label: 'Terms & Conditions', id: 'introduction' },
  { label: 'Cookies', id: 'cookies' },
  { label: 'License', id: 'license' },
  { label: 'Comments', id: 'comments' },
  { label: 'Hyperlinking', id: 'hyperlinking' },
  { label: 'iFrames', id: 'iframes' },
  { label: 'Content Liability', id: 'content-liability' },
  { label: 'Your Privacy', id: 'privacy' },
  { label: 'Reservation of Rights', id: 'reservation' },
  { label: 'Removal of Links', id: 'removal' },
  { label: 'Disclaimer', id: 'disclaimer' },
];

export default function TermsPage() {
  return (
    <Layout>
      <SEO
        title="Terms & Conditions - Apex DeFi Labs"
        description="Read the terms and conditions governing the use of apexdefilabs.com. Understand your rights, our policies, and legal obligations."
        url="https://apexdefilabs.com/terms"
        type="website"
        keywords="Apex DeFi Labs terms, terms of service, legal, conditions of use"
      />

      <div className="terms-page">
        {/* Hero */}
        <section className="terms-hero">
          <div className="terms-hero-overlay" />
          <div className="terms-shell">
            <div className="terms-hero-eyebrow">
              <SectionLabel>Legal</SectionLabel>
            </div>
            <h1 className="terms-hero-title">
              Terms &amp; <em>Conditions</em>
            </h1>
          </div>
        </section>

        {/* Content */}
        <section className="terms-content">
          <div className="terms-shell">
            {/* Table of Contents */}
            <nav className="terms-toc" aria-label="Table of contents">
              <div className="terms-toc-title">Contents</div>
              <ol className="terms-toc-list">
                {tocLinks.map((item) => (
                  <li key={item.id}>
                    <a href={`#${item.id}`}>{item.label}</a>
                  </li>
                ))}
              </ol>
            </nav>

            {/* Sections */}
            {sections.map((section) => (
              <article key={section.id} id={section.id} className="terms-section">
                <span className="terms-section-number">{section.number}</span>
                <h2 className="terms-section-heading">{section.heading}</h2>
                <div className="terms-section-body">{section.body}</div>
              </article>
            ))}

          </div>
        </section>
      </div>
    </Layout>
  );
}
